// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"265":"canvg","297":"xlsx","643":"pdfmake"}[chunkId] + "." + {"265":"0666ed95fc4f7e286602","297":"d9a2ce556ec6ed7c251a","643":"660cd8967f99afbf056e"}[chunkId] + ".js";
};